import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';
import { MasterTableComponent } from './masterTables/masterTables.component';
import { PcaIndexAgentComponent } from './masterTables/pcaIndexAgency/pcaIndexAgency.component';
import { EvaluatorListComponent } from './masterTables/evaluatorList/evaluatorList.component';
import { ProficiencyTestsComponent } from './masterTables/proficiencyTests/proficiencyTests.component';
import { SpecialtyCategoryComponent } from './masterTables/specialtyCategory/specialtyCategory.component';
import { SurveyorsComponent } from './masterTables/surveyors/surveyors.component';
import { UserAdministrationComponent } from './users/user.administration.component';
import { RegistrationLicenseComponent } from './registrationLicense/registrationLicense.component';
import { ReLicenseLabsComponent } from './registrationLicense/reLicenseLabs/reLicenseLabs.component';
import { PrintLabLicenseComponent } from './registrationLicense/printLabLicense/printLabLicense.component';
import { PrintRenewalFormsComponent } from './registrationLicense/printRenewalForms/printRenewalForms.component';
import { PtReportsComponent } from './ptReports/ptReports.component';
import { UploadPtComponent } from './uploadPt/uploadPt.component';
import { CliaUpdatesComponent } from './cliaUpdates/cliaUpdates.component';




const COMPONENTS = [
     MasterTableComponent,
     PcaIndexAgentComponent,
     EvaluatorListComponent,
     ProficiencyTestsComponent,
     SpecialtyCategoryComponent,
     SurveyorsComponent,
     UserAdministrationComponent,
     RegistrationLicenseComponent,
     ReLicenseLabsComponent,
     PrintLabLicenseComponent,
     PrintRenewalFormsComponent,
     PtReportsComponent,
     UploadPtComponent,
     CliaUpdatesComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    AdminRoutingModule,
    SharedModule
  ],
  exports: [
    MasterTableComponent,
    PcaIndexAgentComponent,
    EvaluatorListComponent,
    ProficiencyTestsComponent,
    SpecialtyCategoryComponent,
    SurveyorsComponent,
    UserAdministrationComponent,
    RegistrationLicenseComponent,
    ReLicenseLabsComponent,
    PrintLabLicenseComponent,
    PrintRenewalFormsComponent,
    PtReportsComponent,
    UploadPtComponent,
    CliaUpdatesComponent
  ]
})
export class AdminModule { }